import React, { useState, useEffect, useRef } from "react";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {
  staffSignin,
  authentication,
  isAuth,
  AdminSignin,
  staffSigninOrg,
} from "../../actions/auth";
import { Autocomplete, TextField } from "@mui/material";
import { withRouter } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import {
  CircularProgress,
  IconButton,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";
import { BsPersonFill } from "react-icons/bs";
import { AiFillLock } from "react-icons/ai";
import Controls from "../controls/Controls";
import logo from "../../assets/images/logo.png";
import { useLocation } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useForm } from "../customHelpers/useForm";
import Notify from "../customHelpers/Notify";
import Notification from "../customHelpers/Notification";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Popup from "../customHelpers/Popup";
import AdminSignup from "../../components/forms/superAdminSignup";

const useStyles = makeStyles((theme) => ({
  fields: {
    width: "100%",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  image: {
    maxHeight: "50%",
    maxWidth: "50%",
  },
  logging: {
    marginLeft: "10px",
  },
}));
const initialFValues = {
  input: "",
  password: "",
  organizationId: "",
};
const SigninComponent = (props) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const location = useLocation();
  const { NotifyMessage, notify, setNotify } = Notify();
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => {
    if (showPassword) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const [loading, setLoading] = useState(false);
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const [organization, setSelectedOrganization] = useState(null);
  const [logginError, setLogginError] = useState();

  const classes = useStyles();
  const { history } = props;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("input" in fieldValues)
      temp.input =
        fieldValues.input.length != 0 ? "" : "This field is required.";
    if ("password" in fieldValues)
      temp.password =
        fieldValues.password.length != 0 ? "" : "This field is required.";
    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };
  const handleOrganization = (e) => {
    values.organizationId = e.id;
    setSelectedOrganization(e);
    setOpenPopup(false);
    signinWithOrg(e.id);
  };
  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);
  const HandleSubmit = (e) => {
    e.preventDefault();
    if (organizations.length > 0) {
      signinWithOrg(organization);
      setOpenPopup(true);
    } else {
      if (validate()) {
        setShowForgetPassword(false);
        setLoading(true);
        delete values.logginError;
        delete values.organizationId;
        if (location.pathname.includes("/admin")) {
          AdminSignin(values).then((data) => {
            if (data.err) {
              setLogginError(data.err);
              setLoading(false);
              if (
                data.err === "Password is incorrect" &&
                values.input == "admin"
              ) {
                setShowForgetPassword(true);
              }
            } else {
              if (data.user && data.token) {
                authentication(data, () => {
                  if (isAuth()) {
                    if (isAuth()) {
                      history.push(`/admin`);
                    }
                  }
                });
              } else {
                setLogginError("Something's not right.");
                setLoading(false);
              }
            }
          });
        } else {
          staffSignin(values).then((data) => {
            if (data.err) {
              setLogginError(data.err);
              setLoading(false);
              if (
                data.err === "Password is incorrect" &&
                values.input == "admin"
              ) {
                setShowForgetPassword(true);
              }
            } else if (data.organizations) {
              setOrganizations(data.organizations);
              setLoading(false);
              setOpenPopup(true);
            } else if (data.user && data.token) {
              authentication(data, () => {
                if (isAuth()) {
                  if (isAuth()) {
                    history.push(`/`);
                  }
                }
              });
            } else {
              setLogginError("Something's not right.");
              setLoading(false);
            }
          });
        }
      }
    }
  };
  const [orgError, setOrgError] = useState("");
  const signinWithOrg = (value) => {
    setLoading(true);
    if (!value) {
      return null;
    } else {
      if (validate()) {
        values.organizationId = value;
        setShowForgetPassword(false);
        delete values.logginError;
        staffSigninOrg(values).then((data) => {
          if (data.err) {
            setLogginError(data.err);
            setLoading(false);
            if (
              data.err === "Password is incorrect" &&
              values.input == "admin"
            ) {
              setShowForgetPassword(true);
            }
          } else if (data.user && data.token) {
            authentication(data, () => {
              if (isAuth()) {
                if (isAuth()) {
                  history.push(`/`);
                }
              }
            });
          } else {
            setLogginError("Something's not right.");
            setLoading(false);
          }
        });
      }
    }
  };

  useEffect(() => {
    if (isAuth()) history.push("/");
  }, []);
  const usernameRef = useRef(null);
  useEffect(() => {
    if (usernameRef.current) {
      usernameRef.current.focus();
    }
  }, []);
  return (
    <div className="h-screen bg-gray-200 flex justify-center items-center">
      <Card className="max-w-sm">
        <div className="flex justify-center align-center">
          <img src={logo} className={classes.image} />
        </div>
        <CardContent>
          <div className="mb-8 ">
            <Typography variant="h5" color="primary">
              Login
            </Typography>
            Signin to your account
          </div>
          {history.location.state && (
            <Alert severity="error">{history.location.state}</Alert>
          )}
          {logginError && <Alert severity="error">{logginError}</Alert>}

          {organizations.length > 0 && (
            <Popup
              title="Select Organization"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <Grid container>
                <Grid item xs={6}>
                  <Autocomplete
                    options={organizations}
                    disableClearable
                    getOptionLabel={(option) => `${option.name}`}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        label="Select Organization"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                        }}
                      />
                    )}
                    onChange={(event, value) => handleOrganization(value)}
                  />
                </Grid>
              </Grid>
            </Popup>
          )}
          {orgError && <Typography color="error">{orgError}</Typography>}

          <form onSubmit={HandleSubmit}>
            <Controls.Input
              label="Email or Username"
              value={values.username}
              name="input"
              className={classes.fields}
              inputRef={usernameRef} // Attach the ref here
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <BsPersonFill color="primary" />
                  </InputAdornment>
                ),
              }}
              onChange={handleInputChange}
              error={errors.input}
            />
            <Controls.Input
              label="Password"
              value={values.password}
              name="password"
              className={classes.fields}
              type={showPassword ? "text" : "password"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiFillLock color="primary" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={handleInputChange}
              error={errors.password}
            />

            <CardActions>
              <Controls.Button
                color="primary"
                type="submit"
                text={
                  <>
                    Login
                    {loading && (
                      <CircularProgress
                        size="15px"
                        color="secondary"
                        className={classes.logging}
                      />
                    )}
                  </>
                }
              />
            </CardActions>
          </form>
        </CardContent>
      </Card>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};

export default withRouter(SigninComponent);
